import MuiTooltip, {
  TooltipProps as MuiTooltipProps,
} from '@mui/material/Tooltip';
import { forwardRef } from 'react';
import ValidationError from '../data/ValidationError';

export default forwardRef(function Tooltip(
  { title: titleProp, children, ...rest }: MuiTooltipProps,
  ref,
) {
  if (!titleProp || (Array.isArray(titleProp) && titleProp.length === 0)) {
    return children;
  }

  let title = titleProp;
  if (Array.isArray(titleProp)) {
    title = <ValidationError error={titleProp} />;
  }

  return (
    <MuiTooltip title={title} {...rest} ref={ref}>
      {children}
    </MuiTooltip>
  );
});
